import React from 'react'
import styles from "./ServicesAndSupport.module.scss"
import LightGrayBgWrapper from '../../../components/common/AffiliateCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper'
import { Col, Row } from 'reactstrap'
import TestimonialImage from "../../../assets/images/AffliliatePortal/testimonials.png"
import TermmsAndConditionsImage from "../../../assets/images/AffliliatePortal/terms.png"
import TrainingAndResourcesImage from "../../../assets/images/AffliliatePortal/training.png"
import AffiliateAgreementImage from "../../../assets/images/AffliliatePortal/agreement.png"
import MarketingResourcesImage from "../../../assets/images/AffliliatePortal/resources.png"
import ContactSupportImage from "../../../assets/images/AffliliatePortal/support.png"
import ContactSupportCard from '../../../components/common/AffiliateCommonComponents/Cards/ContactSupportCard'

function ServicesAndSupport() {
    const cardsData = [
        {
            image: TestimonialImage,
            text: "Testimonials"
        },
        {
            image: TermmsAndConditionsImage,
            text: "Terms and Conditions"
        },
        {
            image: TrainingAndResourcesImage,
            text: "Training and Resources"
        },
        {
            image: AffiliateAgreementImage,
            text: "Affiliate Agreement"
        },
        {
            image: MarketingResourcesImage,
            text: "Marketing Resources"
        },
        {
            image: ContactSupportImage,
            text: "Contact and Support"
        },
    ]
    return (
        <LightGrayBgWrapper>
            <h1 className={styles.heading}>Servies and Support</h1>
            <Row>
                {cardsData.map((item, index) => {
                    return (
                        <Col key={index} className='mb-5' md={12} lg={4}>
                            <ContactSupportCard image={item.image} text={item.text} />
                        </Col>
                    )
                })}

            </Row>
        </LightGrayBgWrapper>

    )
}

export default ServicesAndSupport
